var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map",class:{
            'map--event': _vm.parent === 'event',
            'map--shared': _vm.parent === 'shared'
        },attrs:{"id":_vm.mapName}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }